module.exports = __webpack_public_path__ + "img/FISCAL-thumb.b159de57.png";